export default __webpack_public_path__ + "files/media/md-fleet.1dd2aa4c.jpg";